/**
 * Created by robert.lavoie on 6/7/17.
 */

import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { DomSanitizer, Meta, Title  } from '@angular/platform-browser';
import { ActivatedRoute, } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

// Models
import {
  SECTION_TYPE_CONTENT,
  SECTION_TYPE_JOB_SEARCH,
  Site,
  SitePage,
  SiteSection,
} from 'careerpages-base/models';

import { AlternateTypeColors } from 'careerpages-base/utils/colorFormat';

// Services
import { PageService, SiteService, LinkService } from '../../services';

/**
 *
 * @class
 * CustomerSitePageComponent
 *
 * @description
 * This component shows the current page within a customer site
 * This get rendered in the router outlet
 *
 */
@Component({
  templateUrl: './customer-site-page.component.html',
  selector: 'customer-site-page',
  styleUrls: ['./customer-site-page.component.scss'],
})
export class CustomerSitePageComponent implements OnInit{

  public page: SitePage;
  public site: Site;
  public isBrowser: boolean = false;
  private currentPageName: string;
  private readonly SECTION_TYPE_CONTENT: string = SECTION_TYPE_CONTENT;
  private readonly SECTION_TYPE_JOB_SEARCH: string = SECTION_TYPE_JOB_SEARCH;

  constructor(
    private siteService: SiteService,
    private pageService: PageService,
    private route: ActivatedRoute,
    private meta: Meta,
    private title: Title,
    private linkService: LinkService,
    private sanitizer: DomSanitizer,
    @Inject(PLATFORM_ID) private platformId: Object) {}


  ngOnInit() {
     // Because we are using animations we need to only show the job search filter menu when within a browser
    if (isPlatformBrowser(this.platformId)) {
      this.isBrowser = true;
    }

    this.site = this.siteService.getSite();

    // get the current page from the path, if not just default to 'home'
    this.currentPageName = this.route.snapshot.url.length > 0 ? [...this.route.snapshot.url].pop().path : 'home';

    this.page = this.pageService.getCurrentPage(this.currentPageName);

    // Set the canonical url
    this.linkService.addTag({
      rel: 'canonical',
      href: this.siteService.getCurrentUrl()
    });

    if (this.page && this.currentPageName === 'home'){

      this.title.setTitle(`Apply Online to ${this.site.settings.name} Jobs`);

      this.meta.addTags([
        { name: 'description',
          content: `Join the ${this.site.settings.name} team today! We're looking for great candidates like you to join our team. Apply online today!` }
      ]);

    }else if (this.page){

      this.title.setTitle(`${this.currentPageName} | ${this.site.settings.name} Jobs`);

      this.meta.addTags([
        { name: 'description',
          // tslint:disable-next-line:max-line-length
          content: `Learn more about the ${this.site.settings.name} by viewing the ${this.currentPageName} section. We're looking for great candidates like you to join our team. Apply online today!` }
      ]);

    }else{

      this.title.setTitle(`404 | ${this.site.settings.name}`);

      this.meta.addTags([
        { name: 'description', content: `Join the ${this.site.settings.name} team today! We're looking for great candidates like you to join our team. Apply online today!` }
      ]);

    }

  }

  /**
   * Creates the background-image style is the current section has a section background image
   *
   * @return { Object: SiteSection }
   */
  getSectionBackgroundStyle(section: SiteSection): object {
    // If there is no section background image then don't add the style
    if (!section.backgroundImage && !section.backgroundColor) {
      return {};
    }

    const style = {};

    if (section.backgroundImage){
      style['background-image'] = `url(${section.backgroundImage.url})`;
      style['background-size'] =  'cover';
      style['background-position'] =  'center center';
    }

    if (section.backgroundColor){
      style['background-color'] = (AlternateTypeColors[section.backgroundColor]) ? AlternateTypeColors[section.backgroundColor] : this.site.theme[section.backgroundColor];
    }

    return style;

  }

  /**
   * Takes in a section and determines the number of renderable columns
   * @param { SiteSection} section - SiteSection to calculate columns for
   * @returns { number } - the number of columns to render
   */
  private calculateColumns(section: SiteSection): number {
    // Track our column count, defaulting to the current count
    let currentColumnCount = section.columns.length;
    section.columns.map((column) => {
      if (!column.type) currentColumnCount = currentColumnCount - 1;
    });

    // Return the result
    return currentColumnCount;
  }

}
